// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/sass/front/unocms-v4/imports.scss
// module id = 18
// module chunks = 0